/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

import Cookies from 'js-cookie'
import Alpine from 'alpinejs'

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    window.Cookies = Cookies
    window.moment = require('moment');

    require('bootstrap');
    require('tempusdominus-bootstrap-4');

    window.Alpine = Alpine
    Alpine.start()
} catch (e) {
}

$.fn.button = function (action) {
    if (action === 'loading' && this.data('loading-text')) {
        this.data('original-text', this.html()).html(this.data('loading-text')).prop('disabled', true);
    }
    if (action === 'reset' && this.data('original-text')) {
        this.html(this.data('original-text')).prop('disabled', false);
    }
};
